/**
 * A post's community signature (DENG-847), split off its body for display.
 *
 * The composer appends the signature to `message` as plain text after a blank line, and — since
 * this was added — also stores it as `signature`. The text stays in `message` so every reader
 * that doesn't know the field (older app builds, notifications, search) still shows it; readers
 * that do know it cut it off the end here and set it apart (smaller, under a divider).
 *
 * Only a signature that is still exactly where the composer put it is split: an edit that moved
 * or changed it leaves the body whole rather than guessing.
 */
export function splitPostSignature(message: string | null | undefined, signature: string | null | undefined): { body: string; signature: string } {
  const text = message || "";
  const sig = signature || "";
  if (!sig || !text) return { body: text, signature: "" };
  // A reply that is nothing but the signature.
  if (text === sig) return { body: "", signature: sig };
  const suffix = `\n\n${sig}`;
  if (text.endsWith(suffix)) return { body: text.slice(0, -suffix.length), signature: sig };
  return { body: text, signature: "" };
}
